export const isPublic = (state = false) => state;
